<script setup lang="ts">
  import { useRoute, useRouter } from "vue-router";
  import listener from "~/utils/listener";

  const router = useRouter();
  const route = useRoute();

  const onToAbout = (type: string) => {
    if (route.path !== "/about/") {
      router.push({ path: "/about/", query: { type } });
    } else {
      listener.emit("onAboutPosition", type);
    }
  };
</script>

<template>
  <footer class="page-footer">
    <div class="tw-absolute tw-hidden tw-h-full tw-w-[398px] xl:tw-block">
      <img class="tw-size-full" src="~/assets/images/footer/footer-bg-mask.png" />
    </div>
    <div
      class="footer-container tw-flex tw-min-h-[338px] tw-flex-col tw-items-center tw-justify-center tw-border-0 tw-border-b-[1px]
        tw-border-solid tw-border-b-[#F1F1F1] tw-pb-[40px] md:tw-flex-row lg:tw-pb-[60px]">
      <div class="tw-hidden xl:tw-block">
        <div class="company-tags tw-flex tw-h-[115px] tw-items-center">
          <div class="tw-h-[115px] tw-w-[200px]">
            <img class="tw-size-full" src="~/assets/images/footer/slogan.png" />
          </div>
          <div class="divide-line tw-ml-[46px] tw-h-[170px] tw-w-px tw-self-end tw-bg-[#eaeaea]"></div>
        </div>
      </div>
      <div class="tw-flex tw-h-full tw-flex-col tw-pl-0 tw-pt-[48px] sm:tw-flex-row md:tw-pl-[45px]">
        <div class="tw-flex tw-justify-between sm:tw-mr-[80px] sm:tw-justify-normal">
          <div class="about-us tw-flex tw-flex-col tw-text-white sm:tw-mr-[80px]">
            <h3 class="tw-mb-[20px] tw-text-[22px] tw-text-white">关于我们</h3>
            <ul class="tw-text-[18px]">
              <li class="tw-mb-[20px] tw-cursor-pointer" @click="onToAbout('introduction')">公司简介</li>
              <li class="tw-mb-[20px] tw-cursor-pointer" @click="onToAbout('origin')">企业文化</li>
              <li class="tw-mb-[20px] tw-cursor-pointer" @click="onToAbout('honor')">企业荣誉</li>
              <li class="tw-cursor-pointer"><nuxt-link to="/settlement">律师入驻</nuxt-link></li>
            </ul>
          </div>
          <div class="product tw-flex tw-flex-col tw-text-white">
            <h3 class="tw-mb-[20px] tw-text-[22px] tw-text-white">得理产品</h3>
            <ul class="tw-text-[18px]">
              <li class="tw-mb-[20px] tw-cursor-pointer"><nuxt-link to="/ai">小理AI</nuxt-link></li>
              <li class="tw-mb-[20px] tw-cursor-pointer"><nuxt-link to="/search/professional">得理法搜</nuxt-link></li>
              <li class="tw-mb-[20px] tw-cursor-pointer"><nuxt-link to="/paralegal">得理律助</nuxt-link></li>
              <li class="tw-mb-[20px] tw-cursor-pointer"><nuxt-link to="/news">资讯动态</nuxt-link></li>
            </ul>
          </div>
        </div>
        <div class="info tw-mt-[26px] tw-flex tw-flex-col tw-text-white sm:tw-mt-0">
          <h3 class="tw-mb-[20px] tw-text-[22px] tw-text-white">联系我们</h3>
          <ul class="tw-text-[18px]">
            <li class="tw-mb-[20px]">咨询热线：0755-26907610</li>
            <li class="tw-mb-[20px]">投稿邮箱：admin@delilegal.com</li>
            <li class="tw-mb-[20px] tw-flex">
              <div>公司地址：</div>
              <div>
                <div>深圳市丨南山区</div>
                <div>香港中文大学深圳研究院</div>
                <div>2层201、210、211室</div>
              </div>
            </li>
          </ul>
        </div>
        <div class="divide-line tw-ml-[45px] tw-hidden tw-h-[170px] tw-w-px tw-bg-[#eaeaea] md:tw-block"></div>
      </div>
      <div
        class="tw-flex tw-h-full tw-text-center tw-text-[18px] tw-text-white md:tw-flex-col md:tw-justify-center md:tw-pl-[45px]
          lg:tw-flex-row">
        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center lg:tw-mr-[60px]">
          <div class="tw-h-[122px] tw-w-[124px] md:tw-h-[72px] md:tw-w-[72px] lg:tw-h-[122px] lg:tw-w-[124px]">
            <img class="tw-size-full" src="~/assets/images/footer/wx-circle.png" ondragstart="return false;" />
          </div>
          <div class="tw-pt-[10px]">得理公众号</div>
        </div>
        <div
          class="tw-ml-[60px] tw-flex tw-flex-col tw-items-center tw-justify-center md:tw-ml-0 md:tw-mt-[28px] lg:tw-mt-[0]">
          <div class="tw-h-[122px] tw-w-[124px] md:tw-h-[72px] md:tw-w-[72px] lg:tw-h-[122px] lg:tw-w-[124px]">
            <img class="tw-size-full" src="~/assets/images/qrcode/www-service1.png" ondragstart="return false;" />
          </div>
          <div class="tw-pt-[10px]">得理微信客服</div>
        </div>
      </div>
    </div>
    <div
      class="tw-flex tw-min-h-[60px] tw-flex-col tw-items-center tw-justify-center tw-text-[14px] tw-text-white sm:tw-flex-row">
      <div class="tw-mr-[10px] tw-pt-2 tw-leading-[16px] sm:tw-pt-0">
        Copyright &copy; 2024 深圳得理科技有限公司版权所有
      </div>
      <a
        class="tw-my-[2px] sm:tw-my-0"
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502009348">
        <div class="tw-float-left"><img src="~/assets/images/copyright/icon.png" /></div>
        <div class="tw-float-left tw-ml-[3px]">
          <span class="tw-align-text-top">粤公网安备 44030502009348号</span>
        </div>
      </a>
      <a
        class="tw-ml-[10px] tw-pb-2 tw-leading-[16px] sm:tw-pb-0"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        >粤ICP备18045616号-2</a
      >
    </div>
  </footer>
</template>

<style lang="less" scoped>
  .page-footer {
    position: relative;
    width: 100%;
    height: fit-content;
    background: linear-gradient(90deg, #0a5cff 0%, #66f 100%);
  }
</style>
